import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'dsp-transactions',
  templateUrl: 'transactions.container.html'
})
export class TransactionsContainerComponent {
}
